// TODO: Split out this file so the components themselves require their own stylesheet
import React, { PropTypes } from 'react';
import '../assets/stylesheets/app.scss';
import AnalyticsContainer from '../containers/AnalyticsContainer';
import CoreHeaderContainer from '../containers/CoreHeaderContainer';
import DocumentHeadContainer from '../containers/DocumentHeadContainer';
import FooterContainer from '../containers/FooterContainer';
import GlobalProgressBarContainer from '../containers/GlobalProgressBarContainer';
import GlobalMessagingContainer from '../containers/shared/Messaging/GlobalMessagingContainer';
import InternalErrorContainer from '../containers/InternalErrorContainer';
import LoginOverlayContainer from '../containers/LoginOverlayContainer';
import StaffTakeoverContainer from '../containers/StaffTakeoverContainer';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ScreenReaderNavigationContainer from '../containers/ScreenReaderNavigationContainer';
import SystemMessagesContainer from '../containers/SystemMessagesContainer';
import BackToTop from '@bibliocommons/base-back-to-top';

class BCApp extends BcReactComponent {
  render() {
    return (
      <div>
        <AnalyticsContainer />
        <DocumentHeadContainer />
        <ScreenReaderNavigationContainer />
        <GlobalProgressBarContainer />
        <StaffTakeoverContainer />
        <CoreHeaderContainer />
        <div className="container" id="content">
          <SystemMessagesContainer priority="CRITICAL" />
          <InternalErrorContainer>
            {this.props.children}
          </InternalErrorContainer>
        </div>
        <GlobalMessagingContainer />
        <LoginOverlayContainer />
        <FooterContainer />
        <BackToTop />
      </div>
    );
  }
}

BCApp.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default BCApp;



// WEBPACK FOOTER //
// ./app/components/BCApp.jsx